import { Spin } from 'antd';
import React from 'react';

import Dowload from './Dowload';

function PDFOrderContainer(props) {
  const { config, data } = props;

  const { order, items } = data;
  return (
    <div>
      {order && items && config ? <Dowload config={config} items={items} data={order} /> : <Spin />}
    </div>
  );
}

export default PDFOrderContainer;
